var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sec-title-container" },
    [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowBack,
            expression: "isShowBack"
          }
        ],
        staticClass: "back __pointer",
        on: { click: _vm.back }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm._title))]),
      _vm._v(" "),
      _vm.isShowHelp
        ? _c(
            "span",
            { staticClass: "help __pointer", on: { click: _vm._showHelp } },
            [
              _c("i", { staticClass: "icon" }),
              _vm._v(" "),
              _c("span", { staticClass: "help-text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.helpTitle)))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }